export const API_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:3000/';
export const APP_DOMAIN = process.env.REACT_APP_DOMAIN || 'localhost';
export const OLD_PORTAL_URL = process.env.OLD_PORTAL_URL || 'http://localhost';
export const {
  PAYPAL_CLIENT_ID,
  APP_VERSION,
  FRONTEND_VERSION_CHECK_URL,
  BACKEND_HEALTH_CHECK_URL,
} = process.env;
export const PAYMENT_MODEL = { METERED: 'metered', CAPACITY: 'capacity' };
export const METERED_SERVICES = {
  TOLLFREE: 'tollfree',
  UIFN: 'UIFN',
  SHAREDCOST: 'sharedcost',
};

export const CAPACITY_RATE_TYPES = {
  CAPACITY: 'Capacity',
  METERED: 'Metered',
  HYBRID: 'Hybrid',
};
export const CUSTOMER_TYPE = {
  PREPAID: 1,
  POSTPAID_UP: 2,
  POSTPAID_POST: 3,
};

// Order
export const BACKORDER = 'backorder';
export const ORDER = 'order';

export const DOCUMENT_ADDRESS = 5;
export const DOCUMENT_COMPANY_REGISTRATION = 7;
export const DOCUMENT_ADDITIONAL_USER_INFO = 13;
export const DOCUMENT_VAT_OR_COMPANY_REGISTRATION_NUMBER = 14;

export const DOCUMENTS_TO_HIDE = [
  DOCUMENT_ADDRESS,
  DOCUMENT_ADDITIONAL_USER_INFO,
  DOCUMENT_VAT_OR_COMPANY_REGISTRATION_NUMBER,
];

export const OPEN_ORDER_STATUSES = [2, 5];

export const VERSION_CHECK_INTERVAL = 1000 * 30;

export const HTTP_400_BAD_REQUEST = 400;
export const HTTP_401_UNAUTHORIZED = 401;
export const HTTP_500_SERVER_ERROR = 500;
export const HTTP_503_SERVICE_UNAVAILABLE = 503;

export function removeApiFromURL(url) {
  return url.replace('/api/internal/v1', '');
}

export const TERMS_AND_CONDITIONS_URL = removeApiFromURL(
  `${API_URL}uploaded-file/?file=terms-and-conditions`
);
export const PRIVACY_AND_GDPR_URL = removeApiFromURL(
  `${API_URL}uploaded-file/?file=privacy-and-GDPR`
);
